export default "__VITE_ASSET__DZizpR$K__"